import { render, staticRenderFns } from "./rewardDetails.vue?vue&type=template&id=9b37848c&scoped=true&"
import script from "./rewardDetails.vue?vue&type=script&lang=js&"
export * from "./rewardDetails.vue?vue&type=script&lang=js&"
import style0 from "./rewardDetails.vue?vue&type=style&index=0&id=9b37848c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b37848c",
  null
  
)

export default component.exports